import { SelectMultipleValues } from 'elements/minute/sidebar/sidebarComponents/atomic/SelectMultipleValues';
import { ColorPalette } from 'elements/minute/sidebar/sidebarComponents/complex/ColorPalette';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { ALL_COUNTRY_CODES } from 'static/data/Countries';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MapCountryFillSubsection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const map = ctxEdit.map;
    return (
        <S_MapCountryFillSubsection className={props.className}>
            <SidebarSubsection icon={{ iconName: 'flag' }} title={Localization.FILL_COUNTRIES}>
                <SidebarContent>
                    <SelectMultipleValues
                        options={ALL_COUNTRY_CODES.map((country) => ({
                            label: country.name,
                            value: country.code3
                        }))}
                        selectedOptions={ALL_COUNTRY_CODES.filter((country) =>
                            map.fillCountryCodes?.includes(country.code3)
                        ).map((country) => ({ label: country.name, value: country.code3 }))}
                        onChange={(values) => {
                            ctxEdit.updateMap({
                                fillCountryCodes: values.map((e) => e.value)
                            });
                        }}
                    />
                </SidebarContent>

                <ColorPalette
                    value={map.fillCountryColor}
                    pickerAllowed
                    onChange={(color) => {
                        ctxEdit.updateMap({
                            fillCountryColor: color
                        });
                    }}
                />
            </SidebarSubsection>
        </S_MapCountryFillSubsection>
    );
};

const S_MapCountryFillSubsection = styled.div``;
